import {
    TIMESHEET_CREATE_REQUEST,
    TIMESHEET_CREATE_SUCCESS,
    TIMESHEET_CREATE_FAIL,
    TIMESHEET_LIST_REQUEST,
    TIMESHEET_LIST_SUCCESS,
    TIMESHEET_LIST_FAIL,
    TIMESHEET_DETAILS_REQUEST,
    TIMESHEET_DETAILS_SUCCESS,
    TIMESHEET_DETAILS_FAIL,
    TIMESHEET_UPDATE_REQUEST,
    TIMESHEET_UPDATE_SUCCESS,
    TIMESHEET_UPDATE_FAIL,
    TIMESHEET_DELETE_REQUEST,
    TIMESHEET_DELETE_SUCCESS,
    TIMESHEET_DELETE_FAIL,
    TIMESHEET_CREATE_RESET,
    TIMESHEET_DELETE_RESET,
  } from '../constants/timesheetConstants';
  
  export const timesheetCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case TIMESHEET_CREATE_REQUEST:
        return { loading: true };
      case TIMESHEET_CREATE_SUCCESS:
        return { loading: false, success: true, timesheet: action.payload };
      case TIMESHEET_CREATE_FAIL:
        return { loading: false, error: action.payload };
      case TIMESHEET_CREATE_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const timesheetListReducer = (state = { timesheets: [] }, action) => {
    switch (action.type) {
      case TIMESHEET_LIST_REQUEST:
        return { ...state, loading: true }; // Preserve existing timesheets while loading
      case TIMESHEET_LIST_SUCCESS:
        return { loading: false, timesheets: action.payload };
      case TIMESHEET_LIST_FAIL:
        return { loading: false, error: action.payload, timesheets: state.timesheets };
      default:
        return state;
    }
  };
  
  export const timesheetDetailsReducer = (state = { timesheet: {} }, action) => {
    switch (action.type) {
      case TIMESHEET_DETAILS_REQUEST:
        return { loading: true, ...state };
      case TIMESHEET_DETAILS_SUCCESS:
        return { loading: false, timesheet: action.payload };
      case TIMESHEET_DETAILS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const timesheetUpdateReducer = (state = { timesheet: {} }, action) => {
    switch (action.type) {
      case TIMESHEET_UPDATE_REQUEST:
        return { loading: true };
      case TIMESHEET_UPDATE_SUCCESS:
        return { loading: false, success: true, timesheet: action.payload };
      case TIMESHEET_UPDATE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const timesheetDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case TIMESHEET_DELETE_REQUEST:
        return { loading: true };
      case TIMESHEET_DELETE_SUCCESS:
        return { loading: false, success: true, message: action.payload };
      case TIMESHEET_DELETE_FAIL:
        return { loading: false, error: action.payload };
      case TIMESHEET_DELETE_RESET:
        return {};
      default:
        return state;
    }
  };